<template>
  <b-card class="contenedor">

    <div slot="header" class="font-weight-bold">
      Decreto 1630 - Lista de productos
    </div>

    <FormSearch/>

    <DataTable class="mt-5"/>

    <ModalLoadFile/>

    <ModalProcessBackground/>

  </b-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import FormSearch from './FormSearch';
import DataTable from './DataTable';
import ModalLoadFile from './ModalLoadFile'
import ModalProcessBackground from './ModalProcessBackground'

export default {
  name: "Decret1630",
  components: {
    FormSearch,
    DataTable,
    ModalLoadFile,
    ModalProcessBackground
  },
  created() {
    this.load(false);
  },
  methods: {
    ...mapMutations('dashboard', ['load']),
  },
}
</script>

<style scoped>

</style>
